import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthStore } from '../stores';

function isValidJwtLike(token: string | null | undefined): token is string {
  if (!token) return false;
  const normalized = token.trim();
  if (!normalized || normalized === 'undefined' || normalized === 'null') {
    return false;
  }
  return normalized.split('.').length === 3;
}

/**
 * Interceptor que anade el token JWT a todas las peticiones.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if(req.url.includes('/api/communications/unsubscribe/'))return next(req.clone({headers:req.headers.delete('Authorization')}));
  const authStore = inject(AuthStore);
  const storeToken = authStore.token();
  const storageToken = typeof window !== 'undefined' ? window.localStorage.getItem('customer_token') : null;
  const token = isValidJwtLike(storeToken)
    ? storeToken
    : (isValidJwtLike(storageToken) ? storageToken : null);

  if (token && !req.headers.has('Authorization')) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });

  }

  return next(req);
};
